import axios from "axios";
import { setTokenTimestamp } from "./utils/tokenUtils";



const PUBLIC_PATHS = ['/login', '/register', '/reset-password', '/calendar/public'];

const isPublicAppPath = () =>
  PUBLIC_PATHS.some((path) => window.location.pathname.startsWith(path));

const isPublicAuthRequest = (url = '') =>
  url.includes('/login') ||
  url.includes('/refresh') ||
  url.includes('/forgot-password') ||
  url.includes('/reset-password') ||
  url.includes('/verify-reset-token');

const api = axios.create({
  //baseURL: "http://localhost:8080/api/",
 // baseURL: "https://18.216.79.167/api/", //prod ENv
  baseURL: "https://api.technooption.com/api/", //prod ENv with domain
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  }
});

// Add language preference to all requests
api.interceptors.request.use(function (config) {
  const language = localStorage.getItem("app-language") || "en";
  config.headers["Accept-Language"] = language;
  return config;
});

// Add an interceptor to attach the token to each request
api.interceptors.request.use(function (config) {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Ensure language header is set (in case it wasn't set by the first interceptor)
  if (!config.headers["Accept-Language"]) {
    const language = localStorage.getItem("app-language") || "en";
    config.headers["Accept-Language"] = language;
  }

  return config;
});


// Track if we're currently refreshing to prevent multiple simultaneous refresh attempts
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Skip refresh logic for public auth endpoints
    const skipAuthRefresh = isPublicAuthRequest(originalRequest.url);

    if (error.response && error.response.status === 401 && !originalRequest._retry && !skipAuthRefresh) {
      // If already refreshing, queue this request
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      // Try to refresh token
      try {
        const refreshResponse = await api.post('/refresh');
        const newToken = refreshResponse.data.token;

        // Update token in localStorage
        localStorage.setItem('token', newToken);
        setTokenTimestamp();

        // Process queued requests
        processQueue(null, newToken);
        isRefreshing = false;

        // Update the original request with new token
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        // Retry the original request
        return api(originalRequest);
      } catch (refreshError) {
        // If refresh fails, logout user and reject all queued requests
        console.error('Token refresh failed:', refreshError);
        processQueue(refreshError, null);
        isRefreshing = false;
        localStorage.clear();

        if (!isPublicAppPath() && window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
        return Promise.reject(refreshError);
      }
    }
    // Let 403 (permission denied) reach the UI — do not force logout.

    return Promise.reject(error);
  }
);

export default api;
